import React from "react";

function SelectDropdown({ label, options, value, width, onChange }) {
  return (
    <div className="flex-row single-criteria-wrap">
      <label>{label}</label>
      <select className={width} value={value} onChange={onChange} required>
        <option className="select-first" value="">
          {/* Select */}
        </option>
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}

export default SelectDropdown;
